module.exports = __webpack_public_path__ + "static/media/2-en.8dfea466.svg";